import React from 'react';
import { Form } from 'react-bootstrap';
import { useOnlineStore } from '../../../../contexts/onlineStoreContext';
import InvoiceHttpService from '../../../../services/http/invoice-http';
import { formatCurrency } from '../../../../utils/strings';
import { InterestRatesProps } from '..';
import handleResponseError from '../../../../utils/handleResponseError';

interface Props {
    invoice: any;
    disabled: boolean;
    maxInstallments: number;
    interestRates: InterestRatesProps[];
}

const CreditCard: React.FC<Props> = ({
    invoice,
    disabled,
    maxInstallments,
    interestRates,
}) => {
    const { setCart } = useOnlineStore();

    const getAdditionalText = (installment: number) => {
        let total = invoice.subTotalWithDiscount;

        if (installment === invoice.cardMaxInstallmentNumber) {
            return `de ${formatCurrency(
                (invoice.totalInvoice) / installment,
            )} ${
                +invoice.interestPercentage > 0 ? 'com' : 'sem'
            } juros (total ${formatCurrency(invoice.totalInvoice)})`;
        }
        let interest = 0;
        let hasInterest = 'sem';

        const installmentInterest = interestRates.find(
            (ir) => ir.installment === installment,
        );

        if (installmentInterest && +installmentInterest.percentage > 0) {
            interest = (total * +installmentInterest.percentage) / 100;
            hasInterest = 'com';
        }

        total += interest;
        total += +invoice.grossCommission;

        const installmentValue = total / installment;

        return `de ${formatCurrency(
            installmentValue,
        )} ${hasInterest} juros (total ${formatCurrency(total)})`;
    };

    const handleInstallmentChange = async (event: any) => {
        const updatedInvoice = { ...invoice };

        updatedInvoice.cardMaxInstallmentNumber = Number(event.target.value);

        try {
            const response = await InvoiceHttpService.update(updatedInvoice);

            setCart(response.data);
        } catch (error) {
            handleResponseError(
                error,
                'Ocorreu um erro ao salvar parcelamento.',
            );
        }
    };

    return (
        <>
            <Form
                style={{
                    width: '100%',
                }}
            >
                <Form.Group
                    className="pl-4 pr-4 mb-5 mt-3"
                    controlId="formBasicName"
                >
                    <Form.Label>Parcelamento</Form.Label>
                    <Form.Control
                        disabled={disabled}
                        onChange={handleInstallmentChange}
                        name="installments"
                        type="text"
                        value={invoice?.cardMaxInstallmentNumber}
                        as="select"
                    >
                        {invoice.totalInvoice > 0 && (
                            <>
                                {[
                                    ...Array.from(
                                        { length: maxInstallments },
                                        (_, i) => i + 1,
                                    ),
                                ].map((installment: number, index: number) => (
                                    <option key={index} value={installment}>
                                        {`${installment}x ${getAdditionalText(
                                            installment,
                                        )}`}
                                    </option>
                                ))}
                            </>
                        )}
                    </Form.Control>
                </Form.Group>
            </Form>
        </>
    );
};

export default CreditCard;
